import PlaybackTime, { PlaybackTimeProps } from './PlaybackTime';

export default PlaybackTime;
export type { PlaybackTimeProps };
